/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { LedgerStatementMatch } from './LedgerStatementMatch.js';
import {
    LedgerStatementMatchFromJSON,
    LedgerStatementMatchFromJSONTyped,
    LedgerStatementMatchToJSON,
} from './LedgerStatementMatch.js';

/**
 * 
 * @export
 * @interface ScorecardSectionResult
 */
export interface ScorecardSectionResult {
    /**
     * 
     * @type {string}
     * @memberof ScorecardSectionResult
     */
    reason?: string;
    /**
     * 
     * @type {LedgerStatementMatch}
     * @memberof ScorecardSectionResult
     */
    statementMatch?: LedgerStatementMatch;
}

/**
 * Check if a given object implements the ScorecardSectionResult interface.
 */
export function instanceOfScorecardSectionResult(value: object): boolean {
    return true;
}

export function ScorecardSectionResultFromJSON(json: any): ScorecardSectionResult {
    return ScorecardSectionResultFromJSONTyped(json, false);
}

export function ScorecardSectionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardSectionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
        'statementMatch': json['statementMatch'] == null ? undefined : LedgerStatementMatchFromJSON(json['statementMatch']),
    };
}

export function ScorecardSectionResultToJSON(value?: ScorecardSectionResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
        'statementMatch': LedgerStatementMatchToJSON(value['statementMatch']),
    };
}

